import Trucks from '../components/trucks/Trucks';
import TrucksCreate from '../components/trucks/TrucksCreate';
import TrucksEdit from '../components/trucks/TrucksEdit';
import TrucksCalendar from '../components/trucks/TrucksCalendar';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/trucks',
  component: Template,
  children: [
    {
      path: '',
      name: 'Trucks',
      component: Trucks,
      meta: {
        title: 'Trucks - Mod24',
      },
    },
    {
      path: 'create',
      name: 'TrucksCreate',
      component: TrucksCreate,
      meta: {
        title: 'Create Truck - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'TrucksEdit',
      component: TrucksEdit,
      meta: {
        title: 'Edit Truck - Mod24',
      },
    },
    {
      path: 'calendar/:id',
      name: 'TrucksCalendar',
      component: TrucksCalendar,
      meta: {
        title: 'Trucks Calendar - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/trucksRoutes.js